import React from 'react'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles';

const TypographyLabel = styled(Typography)(() => (
  {
    whiteSpace: 'break-spaces',
    wordBreak: 'break-word',
  }))

export const MyMLabel = (props) => {
  const { fontSize, align, ...other } = props;
  return (
    <TypographyLabel style={{ fontSize: fontSize ?? '1rem' }} variant="body2" align={align ?? 'inherit'} {...other}>
      {props.children}
    </TypographyLabel>
  )
}

export const MyMVariantLabel = (props) => {
  const { variant, ...other } = props;
  return (
    <TypographyLabel variant={variant} {...other}>
      {props.children}
    </TypographyLabel>
  )
}
